module.exports = __webpack_public_path__ + "static/media/companyInfo.2c153514.less";